<template>
  <div class="px-3 mb-6 pt-4">
    <v-layout no-gutters>
      <h2 class="checkout-h2">Política de Compra</h2>
    </v-layout>
    <v-layout class="py-1" no-gutters>
      <v-card
        outlined
        elevation="0"
        class="rounded-lg pa-3 my-4"
        width="100%"
        height="200"
        max-height="200"
        style="overflow: auto; border: 2px solid #ddd"
      >
        <span v-html="eventDetails ? eventDetails.politica_compra : ''"></span>
      </v-card>
    </v-layout>
    <v-layout class="mb-3" no-gutters>
      <v-checkbox
        class="ma-0 pa-0"
        hide-details
        label="Aceito os termos"
        required
        color="primary"
        :rules="[rulesValidation.required]"
        v-model="accept"
        @change="changeCheckTerms"
      ></v-checkbox>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validationMixin from '../../mixins/validationMixin.vue';
export default {
  mixins: [validationMixin],
  computed: {
    ...mapGetters(['eventDetails']),
  },
  data() {
    return {
      accept: false,
    };
  },
  methods: {
    changeCheckTerms() {
      this.$store.commit('SET_CHECK_TERMS', this.accept);
    },
  },
  mounted() {
    this.$store.commit('SET_CHECK_TERMS', false);
  },
};
</script>
